// extracted by mini-css-extract-plugin
export default {"portfolioSection":"CardBody_portfolioSection__GEdgF","cuerpoEfecto":"CardBody_cuerpoEfecto__A-sLQ","visitar":"CardBody_visitar__f-R3U"};